/**
 * Smart Task operations work-item lists + equipment-queue blobs — TotalAccessOfflineDB `app-shell` KV.
 */

import appShellStore from './appShellStore';

const LIST_ENTITY_PREFIX = 'mast_sync_ops_wi_list:';
const EQUIP_ENTITY_PREFIX = 'mast_sync_eq:';

/** Cached operations-side work item snapshots (arrays). */
export async function loadOperationsWorkItemsList<T>(clientId: number, listKey: string): Promise<T[]> {
  const entityId = `${LIST_ENTITY_PREFIX}${listKey}`;
  const boxed = await appShellStore.getJsonUnifiedOnly<{ items?: T[] }>(clientId, entityId);
  if (boxed && Array.isArray(boxed.items)) {
    return boxed.items;
  }
  return [];
}

export async function saveOperationsWorkItemsList<T>(clientId: number, listKey: string, items: T[]): Promise<void> {
  await appShellStore.upsertJson(clientId, `${LIST_ENTITY_PREFIX}${listKey}`, { items });
}

export async function saveQueuedEquipmentRecord(
  clientId: number,
  storageKey: string,
  record: {
    item_id: string | number;
    action: string;
    payload: Record<string, unknown>;
    photos?: Record<string, string>;
  },
): Promise<void> {
  await appShellStore.upsertJson(clientId, `${EQUIP_ENTITY_PREFIX}${storageKey}`, {
    record,
    sync_status: 'pending' as const,
  });
}
